import {toString} from 'lodash-es';

export enum WebStorageProperties {
  AppSessionExpiry = 'appSessionExpiry',
  QuoteRequest = 'quoteRequest',
  QuoteResponse = '',
  SessionActive = 'sessionActive',
}

export const sessionStorageSetItem = (
  key: WebStorageProperties,
  value: string
): string => {
  try {
    const sessionValue = sessionStorage.setItem(key, value);

    return toString(sessionValue);
  } catch (error) {
    return toString(error);
  }
};

export const sessionStorageGetItem = (key: WebStorageProperties): string => {
  try {
    const sessionValue = sessionStorage.getItem(key);

    return JSON.parse(toString(sessionValue));
  } catch (error) {
    return toString(error);
  }
};

export const sessionStorageRemoveItem = (key: WebStorageProperties) => {
  try {
    sessionStorage.removeItem(key);

    return false;
  } catch (error) {
    return toString(error);
  }
};
